import React, { useState } from 'react';
import styles from '../../css/index.module.scss';
import './css/index.scss';
import moment from 'moment';
import MyButton from '../../../../components/MyButton';
import Api from '../../../../Api';
import { REPORT_MODAL_STATES } from '../../constants';
import ReportsModal from '../ReportsModal';
import EmptyHeight from '../../../../components/EmptyHeight';
import { UNNAMED_USER_EMAIL } from '../../../../helpers/constants';

function ReportInfos({ complaints, updateComplaints }) {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalState, setModalState] = useState('');
  const [complaintId, setComplaintId] = useState(null);
  const [selectedPhoto, setSelectedPhoto] = useState({});

  const onApproveClick = (complaint) => {
    if (complaint && complaint._id) {
      setModalState(REPORT_MODAL_STATES.seen);
      setIsModalVisible(true);
      setComplaintId(complaint._id);
    } else {
      console.error('Invalid complaint object:', complaint);
    }
  };

  const onPhotoItemClick = (photo, complaint) => () => {
    setSelectedPhoto({ url: photo });
    setModalState(REPORT_MODAL_STATES.viewPhoto);
    setIsModalVisible(true);
    setComplaintId(complaint);
  };

  return (
    <>
      <ReportsModal
        isVisible={isModalVisible}
        setIsVisible={setIsModalVisible}
        modalState={modalState}
        selectedPhoto={selectedPhoto}
        setSelectedPhoto={setSelectedPhoto}
        complaintId={complaintId}
        updateComplaints={updateComplaints}
        isOrganizationOrInfo
        modalApproveInfoText="Вы уверены, что хотите пометить информацию как прочитанное?"
      />
      {complaints?.length ? complaints.map((item, index) => (
        <div className={styles.reportItem} key={item._id}>
          <div className={styles.reportRow}>
            <div className={styles.article}>
              <img src={Api.url + item.subject?.photo_url} alt="file" className={styles.articlePhoto} />
              <div className={styles.articleRight}>
                <div className={styles.articleHeader}>
                  <p className={styles.articleTitle}>{item.subject?.name}</p>
                  <p className={styles.articleSort}>
                    №
                    {item.subject?.sort}
                  </p>
                </div>
                <div className={styles.articleFooter}>
                  <p className={styles.articleDate}>{moment(item.subject?.updatedAt).format('DD.MM.YYYY')}</p>
                </div>
              </div>
            </div>

            <div style={{ width: '300px' }}>
              <p className={styles.text}>{moment(item.updatedAt).format('DD/MM/YYYY')}</p>
              <EmptyHeight height={8} />
              <p className={styles.textGrey}>Дата</p>
            </div>
            <MyButton
              text="Ок"
              onClick={() => onApproveClick(item)}
            />
          </div>
          <EmptyHeight height={15} />
          <div className={styles.reportRow}>
            <div style={{ width: '470px' }}>
              <p className={styles.textGrey}>Описание от заявителя</p>
              <EmptyHeight height={8} />
              <p className={styles.text}>
                {item.text}
              </p>
            </div>

            {item.from_user?.email && item.from_user?.email !== UNNAMED_USER_EMAIL && (
              <div style={{ width: '180px' }}>
                <p className={styles.textGrey}>Данные заявителя</p>
                <EmptyHeight height={8} />
                <p className={styles.text}>
                  {`${item.from_user?.email} ${item.from_user?.display_name}`}
                </p>
              </div>
            )}

            <div style={{ width: '240px' }}>
              <p className={styles.textGrey}>Приложения от заявителя</p>
              <EmptyHeight height={8} />
              <div className={styles.photosRow}>
                {item.photos.map((photoId, i) => (
                  <img
                    key={i}
                    src={`${Api.url}/${photoId.preview_url}`}
                    alt=""
                    className={styles.photo}
                    onClick={onPhotoItemClick(photoId.url, item._id)}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      )) : <p style={{ marginTop: 40, marginLeft: 10 }}>Пусто.</p>}
    </>
  );
}

export default ReportInfos;
